import { getFormattedDateTime } from '@eventbrite/datetime-fns';
import { gettext } from '@eventbrite/i18n';
import { CheckoutState } from '../../state';
import { getAppLocale } from '../app';
import { getEventEndDate, getEventStartDate } from './pureSelectors';

export const getEventFromStartDateToEndDate = (state: CheckoutState) => {
    const start = getEventStartDate(state);
    const end = getEventEndDate(state);
    const dateFormat = 'MMM dd yyyy';

    const startDate = getFormattedDateTime(
        start.utc,
        false,
        start.timezone,
        getAppLocale(state),
        dateFormat,
    );

    const endDate = getFormattedDateTime(
        end.utc,
        false,
        start.timezone,
        getAppLocale(state),
        dateFormat,
    );

    return gettext('From %(startDate)s to %(endDate)s', {
        startDate,
        endDate,
    }).toString();
};
